import React, { memo, useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AuthProvider } from './contexts/AuthContext'
import AuthHandler from './components/AuthHandler'
import { Login } from './components/Login'
import { AdminDashboard } from './components/AdminDashboard'
import { ProtectedRoute } from './components/ProtectedRoute'
import ErrorBoundary from './components/ErrorBoundary'
import AppRoutes from './routes'
import { PageVisibilityProvider } from './contexts/PageVisibilityContext'
import { supabase } from './utils/supabase'
import SyncStatusPage from './components/SyncStatusPage'

// Create theme based on your guidelines
const theme = createTheme({
  palette: {
    primary: {
      main: '#8A42EC',
      light: '#EFE9FB',
      dark: '#7129E0',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
  },
})

// Use React.memo to prevent unnecessary re-renders
function App() {
  // Critical fix: Remove auth tokens from URL after successful login
  // This prevents repeated reload issues while still allowing OAuth to work
  useEffect(() => {
    console.log('[App] Checking for auth session and cleaning URL if needed');
    supabase.auth.getSession().then(({ data }) => {
      console.log('[App] On mount, Supabase session:', data.session);
      if (data.session) {
        console.log('[App] Auth session found, cleaning URL parameters');
        // Remove auth params from URL after successful login
        const url = new URL(window.location);
        if (url.hash.includes('access_token') || url.hash.includes('refresh_token')) {
          console.log('[App] Removing auth tokens from URL');
          url.hash = '';
          window.history.replaceState({}, document.title, url.pathname);
        }
      }
    });
  }, []);

  return (
    <ErrorBoundary>
      <PageVisibilityProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <AuthHandler />
            <Router>
              <AppRoutes />
            </Router>
          </AuthProvider>
        </ThemeProvider>
      </PageVisibilityProvider>
    </ErrorBoundary>
  )
}

// Export a memoized version of the App component
export default memo(App) 